import {
  canonicalJson,
  type JsonValue,
} from "../../../../packages/core/src/canonical.ts";

/**
 * The staleness fingerprint (session 5 gate 9): sha256 over the canonical
 * form of the assembled run input, in exactly the format the kernel writes
 * into `evaluations.input_hash`.
 *
 * The canonicalisation is the KERNEL'S OWN MODULE, imported as source — not a
 * console reimplementation, so it cannot drift from what the Edge Function
 * hashed. Only the digest differs mechanically: the kernel uses `node:crypto`,
 * which does not exist in a browser, so the same standard SHA-256 comes from
 * Web Crypto here. Both produce `sha256:<hex over utf-8 canonical bytes>`.
 *
 * This computes an identity, never a result: comparing it against a stored
 * `input_hash` says "the responses changed since this evaluation" and nothing
 * else. No coverage, qualification, score or cap logic lives anywhere near it
 * (gate 2).
 */
export async function inputFingerprint(input: unknown): Promise<string> {
  const canonical = canonicalJson(input as JsonValue);
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(canonical),
  );
  const hex = Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return `sha256:${hex}`;
}
